import styled from 'styled-components'
import Image from "next/image";
import grabColor from 'src/utils/grabColor'
import Container from 'src/styles/Container'
import { H1 } from 'src/styles/Typography'
import Layout from 'src/components/Layout'
import RichTextResponse from 'src/components/RichText'
import KeyTakeaways from 'src/components/Article/KeyTakeaways'
import TableOfContents from 'src/components/Article/TableOfContents'

const PagePageIndex = ({ page, verticals }) => {
  return (
    <Layout
      verticals={verticals}
      seo={page?.seo || { title: page?.title || 'Page Title Missing' }}
      footer={{ noBorder: true }}
    >
      <main>
        <Container>
          <HeadingWrapper>
            <StyledH1>{page?.title}</StyledH1>
            {page?.hero?.photo?.url && (
              <PhotoWrapper>
                <Image
                  src={page.hero.photo.url}
                  quality={50}
                  width={page.hero.photo.width}
                  height={page.hero.photo.height}
                  style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                  alt={page?.hero?.photo?.description || ''}
                />
              </PhotoWrapper>
            )}
          </HeadingWrapper>
        </Container>

        <RichTextWrapper>
          <Container>
            <TableOfContents>
              <RichTextContainer>
                <RichTextResponse richTextResponse={page?.pageContent} />
              </RichTextContainer>
            </TableOfContents>
          </Container>
        </RichTextWrapper>
      </main>
    </Layout>
  )
}

const PhotoWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 250px;
`

const StyledH1 = styled(H1)`
  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    font-size: 30px;
    line-height: 36px;
  }
`

const HeadingWrapper = styled.div`
  max-width: 800px;
  margin: 2rem auto;
`

const RichTextWrapper = styled.div`
  background: ${grabColor('backgroundLight')};
  padding: 2rem 0;
`

const RichTextContainer = styled.div`
  max-width: 664px;
  width: 100%;
  margin: 0 3rem 3rem;

  @media (max-width: ${(props) => props.theme.breakpoints.desktop}) {
    margin: 3rem 0;
  }
`

export default PagePageIndex
